import axios from "axios";
import userApi from "@/libs/api/user";
import projectsApi from "@/libs/api/projects"
import assistantApi from "@/libs/api/assistant"

import EventBus from "@/libs/event-bus";
import events from "@/libs/events";


const browserOrigin = typeof window !== "undefined" ? window.location.origin : "";
const apiServer = browserOrigin || process.env.VUE_APP_SERVER;
const  apiPrefix = "/api/v1.0/";


axios.defaults.withCredentials = true;
axios.defaults.baseURL=apiServer;



const api = {

    server: apiServer,

    send:{
        urlWithPrefix(endpoint){
            return apiPrefix + endpoint;
        },
        fullPath(endpoint){
            return apiServer + this.urlWithPrefix(endpoint);
        },

        __promise(type, endpoint, payload, config){
            let axPromise = null;
            let configObj = config ?? {};
            switch (type){
                case "get":
                    axPromise = axios.get(this.urlWithPrefix(endpoint), configObj);
                    break;

                case "post":
                    axPromise =  axios.post(this.urlWithPrefix(endpoint), payload, configObj);
                    break;

                case "put":
                    axPromise =  axios.put(this.urlWithPrefix(endpoint), payload, configObj);
                    break;

                case "delete":
                    axPromise =  axios.delete(this.urlWithPrefix(endpoint), configObj);
                    break;

                default:
                    throw new Error("Incorrect request type: "+ type);
            }
            return new Promise((resolve, reject) => {
                axPromise.then(response => resolve(response.data))
                    .catch(err => {
                        const status = err.response?.status ?? err.request?.status;
                        const errorCode = err.response?.data?.error;
                        if(status === 401 && errorCode !== 'testdepo_error'){
                            EventBus.$emit(events.STATUS_401_UNAUTHORIZED);
                        }
                        reject(err);
                    })
            });

        },
        get(url, config){
            return this.__promise('get', url, null, config)
        },
        post(url, payload, config){
            return this.__promise('post', url, payload, config)
        },
        put(url, payload, config){
            return this.__promise('put', url, payload, config)
        },
        delete(url, config){
            return this.__promise('delete', url, config)
        },
    },

    getUser(){ return userApi.get(this) },
    getProjects() { return projectsApi.list(this)},
    getFoldersAndProjects() { return projectsApi.listWithFolders(this)},
    getExplorerData() { return projectsApi.explorer(this)},
    searchProjects(query) { return projectsApi.search(this, query)},
    viewProject(project_id) { return projectsApi.view(this,project_id)},
    updateProjectName(project_id, name) { return projectsApi.updateProjectName(this,project_id, name)},
    updateProjectPublicAccess(project_id, allowAccess, passwordField, accessComment) { return projectsApi.updateProjectPublicAccess(this,project_id, allowAccess, passwordField, accessComment)},

    createFolder(folder_name, parent_folder_id) {return projectsApi.createFolder(this,folder_name,parent_folder_id)},
    deleteFolder(folder_id) { return projectsApi.deleteFolder(this, folder_id) },
    renameFolder(folder_id, folder_name) { return projectsApi.updateFolderName(this, folder_id, folder_name)},

    copyProject(project_id) { return projectsApi.copyProject(this,project_id)},
    replaceProject(project_id, folder_id) { return projectsApi.replaceProject(this,project_id, folder_id)},
    createProject(project_name, folder_id) { return projectsApi.createProject(this,project_name, folder_id)},
    deleteProject(project_id) { return projectsApi.deleteProject(this,project_id)},

    viewProjectData(project_id, params = {}) { return projectsApi.getData(this, project_id, params)},
    setDataSource(project_id, source, confirmRowCount = null) { return projectsApi.setDataSource(this, project_id, source, confirmRowCount)},

    // Row CRUD
    addDataRow(project_id, data) { return projectsApi.addDataRow(this, project_id, data) },
    updateDataRow(project_id, row, data) { return projectsApi.updateDataRow(this, project_id, row, data) },
    deleteDataRow(project_id, row) { return projectsApi.deleteDataRow(this, project_id, row) },

    // Keys management
    createDataKeys(project_id, fields, confirmRowCount = null) { return projectsApi.createDataKeys(this, project_id, fields, confirmRowCount) },
    downloadDataTemplate(project_id) { return projectsApi.downloadDataTemplate(this, project_id) },

    // TestDepo integration
    fetchTestDepoFields(project_id, testId, testdepoHost = null, apiKey = null) { return projectsApi.fetchTestDepoFields(this, project_id, testId, testdepoHost, apiKey) },

    uploadDataFile(project_id, files, confirmRowCount = null) { return projectsApi.uploadData(this,project_id, files, confirmRowCount)},
    downloadFileForNumber(project_id, row_number) {return projectsApi.downloadFileForRowNumber(this, project_id, row_number)},
    downloadFiles(project_id, filenameKey) {return projectsApi.downloadAllFiles(this, project_id, filenameKey)},

    viewProjectTemplate(project_id) { return projectsApi.getTemplate(this,project_id)},
    uploadProjectTemplateImage(project_id, files) { return projectsApi.uploadTemplateImage(this,project_id, files)},
    processBackground(project_id, data) { return projectsApi.processBackground(this, project_id, data)},
    copyTemplateImageFromLibrary(project_id, backgroundId) {return projectsApi.copyTemplateImageFromLibrary(this,project_id, backgroundId)},
    createProjectTemplate(project_id, data) { return projectsApi.createProjectTemplate(this,project_id, data)},
    updateProjectTemplate(project_id, data) { return projectsApi.updateProjectTemplate(this,project_id, data)},

    getAvailableFonts()  { return projectsApi.availableFonts(this)},

    getBgTemplates() { return projectsApi.listBgTemplates(this)},

    loadAccessSheet(project_id) {return projectsApi.loadAccessSheet(this, project_id)},

    // AI-ассистент
    sendAiMessage(project_id, message, file, onEvent) { return assistantApi.sendMessageStream(this, project_id, message, file, onEvent) },
    getAiHistory(project_id) { return assistantApi.history(this, project_id) },
    clearAiHistory(project_id) { return assistantApi.clear(this, project_id) },
    getBackgroundVersions(project_id) { return assistantApi.backgroundVersions(this, project_id) },
    applyBackground(project_id, asset_id) { return assistantApi.applyBackground(this, project_id, asset_id) },
    restoreBackground(project_id, asset_id) { return assistantApi.restoreBackground(this, project_id, asset_id) },
    createBackgroundVariation(project_id, asset_id) { return assistantApi.createBackgroundVariation(this, project_id, asset_id) },
    deleteBackgroundCandidate(project_id, asset_id) { return assistantApi.deleteBackgroundCandidate(this, project_id, asset_id) }


};

export default api;
